
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Statistics from './components/Statistics';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Countries from './components/Countries';
import Benefits from './components/Benefits';
import Security from './components/Security';
import CTA from './components/CTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Statistics />
      <Services />
      <Testimonials />
      <Countries />
      <Benefits />
      <Security />
      <CTA />
      <Footer />
    </div>
  );
}
